import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import { Link } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { UI_CONSTANTS } from "../../utils/constants";
import editImage from "../../assets/images/icons/edit-2.svg";
import viewIcon from "../../assets/images/icons/eye.svg";
import Modal from "../../commons/Modal/Modal";

function NewsManagement() {
  const [loading, setLoading] = useState(false);
  const [newsItems, setNewsItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10); // Default limit per page
  const [totalPages, setTotalPages] = useState(1);
  const [logoutModal, setLogoutModal] = useState({ value: false });
  const [newsToDelete, setNewsToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const getNews = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("page", currentPage.toString());
      params.append("limit", limit.toString());
      if (searchTerm) {
        params.append("search", searchTerm);
      }

      const response = await handleApiCall("get", `${endpoints.getNewslist}?${params.toString()}`);
      if (response?.data?.code === 200 || response?.data?.code === "200" || response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        const newsData = response?.data?.data?.data || response?.data?.data || [];
        setNewsItems(newsData);
        setTotalPages(response?.data?.data?.pagination?.totalPages || response?.data?.pagination?.totalPages || 1);
      }
      // API errors are already handled by handleApiCall
    } catch (error) {
      console.error("Error fetching news:", error);
      // Network errors are already handled by handleApiCall
    } finally {
      setLoading(false);
    }
  }, [currentPage, limit, searchTerm]);

  useEffect(() => {
    getNews();
  }, [getNews]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleStatusToggle = async (newsId, currentStatus) => {
    try {
      const newStatus = currentStatus === 1 ? 0 : 1;

      const response = await handleApiCall("patch", `${endpoints.updateNewsState}/${newsId}`, {
        status: newStatus,
      });

      if (
        response?.data?.code === 200 ||
        response?.data?.code === "200" ||
        response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS
      ) {
        toast.success("News status updated successfully!");
        getNews();
      }
    } catch (error) {
      console.error("Error updating news status:", error);
      toast.error("Failed to update news status");
    }
  };

  const handleDeleteClick = (newsId) => {
    setNewsToDelete(newsId);
    setLogoutModal({ value: true });
  };

  const handleDeleteConfirm = async () => {
    if (!newsToDelete) return;

    setDeleting(true);
    try {
      // const response = await handleApiCall("delete", `${endpoints.deleteBanner}/${newsToDelete}`);

      // if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
      //   toast.success("News deleted successfully!");
      //   setLogoutModal({ value: false });
      //   setNewsToDelete(null);
      //   getNews();
      // }
    } catch (error) {
      console.error("Error deleting news:", error);
    } finally {
      setDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setLogoutModal({ value: false });
    setNewsToDelete(null);
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-4 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">News Management</h3>
              <Link to="/add-news" className="btn btn-primary rounded-2 px-3 ml-auto">
                {UI_CONSTANTS.BUTTON_LABELS.CREATE_NEW} <span className="ml-2">+</span>
              </Link>
            </div>

            {/* <div className="row mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control search-icon left-icon border"
                    placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div> */}

            <div className="table-responsive px-0">
              <table className="table table-striped trim">
                <thead>
                  <tr>
                    <th width="80">{UI_CONSTANTS.TABLE_HEADERS.SR_NO}</th>
                    <th width="150">{UI_CONSTANTS.TABLE_HEADERS.NAME}</th>
                    <th>Type</th>
                    <th>Media</th>
                    <th>Order By</th>
                    <th>{UI_CONSTANTS.TABLE_HEADERS.STATUS}</th>
                    <th className="text-center">{UI_CONSTANTS.TABLE_HEADERS.ACTIONS}</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        <div className="spinner-border" role="status">
                          <span className="sr-only">{UI_CONSTANTS.BUTTON_LABELS.LOADING}</span>
                        </div>
                      </td>
                    </tr>
                  ) : newsItems.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-4">
                        {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                      </td>
                    </tr>
                  ) : (
                    newsItems.map((news, index) => (
                      <tr key={news._id}>
                        <td>{(currentPage - 1) * limit + index + 1}</td>
                        <td className="text-center">{news.title_english || news.title || UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}</td>
                        <td className="text-center text-capitalize">{(news.type || news.content_type || "").toLowerCase()}</td>
                        <td>
                          <div className="sm-img">
                            {(() => {
                              const type = (news.type || news.content_type || "").toLowerCase();
                              if (type === "video" && (news.desktop_news || news.news || news.video)) {
                                const videoSrc = news.desktop_news || news.news || news.video;
                                return (
                                  <video
                                    src={videoSrc}
                                    style={{
                                      width: "120px",
                                      height: "70px",
                                      objectFit: "cover",
                                    }}
                                    controls
                                  />
                                );
                              }
                              if (type === "image" && (news.desktop_news || news.news || news.image || news.thumbnail_image)) {
                                const imageSrc = news.desktop_news || news.news || news.image || news.thumbnail_image;
                                return (
                                  <img
                                    src={imageSrc}
                                    alt="news"
                                    style={{
                                      width: "120px",
                                      height: "70px",
                                      objectFit: "cover",
                                      borderRadius: "4px",
                                    }}
                                  />
                                );
                              }
                              return <span style={{ color: "#999" }}>No media</span>;
                            })()}
                          </div>
                        </td>
                        <td>{news.order_no}</td>
                        <td>
                          <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              checked={news.status === 1}
                              onChange={() => handleStatusToggle(news._id, news.status)}
                            />
                            <span className="custom-control-label custom-toggle" />
                          </label>
                        </td>
                        <td>
                          <div className="d-flex align-items-center justify-content-center">
                            <Link to={`/view-news/${news._id}`} className="btn btn-link p-0 mx-2" title={UI_CONSTANTS.BUTTON_LABELS.VIEW || "View"}>
                              <img
                                src={viewIcon}
                                alt={UI_CONSTANTS.BUTTON_LABELS.VIEW || "View"}
                                style={{ width: 20, height: 20, filter: "brightness(0) invert(1)", opacity: 0.95 }}
                                className="mr-2"
                              />
                            </Link>
                            <Link to={`/edit-news/${news._id}`} className="btn btn-link p-0 mx-2" title={UI_CONSTANTS.BUTTON_LABELS.EDIT}>
                              <img src={editImage} alt={UI_CONSTANTS.BUTTON_LABELS.EDIT} className="mr-2" />
                            </Link>
                            {/* <button className="btn btn-link p-0 mx-2" onClick={() => handleDeleteClick(news._id)}>
                              <img src={DeleteIcon} alt={UI_CONSTANTS.BUTTON_LABELS.DELETE} />
                            </button> */}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-4">
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        {UI_CONSTANTS.BUTTON_LABELS.PREVIOUS || "Previous"}
                      </button>
                    </li>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page)}>
                          {page}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        {UI_CONSTANTS.BUTTON_LABELS.NEXT || "Next"}
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal show={logoutModal.value} onClose={handleDeleteCancel} style={{ zIndex: "1000" }} className=" shadow-none">
        <div className="modal-dialog modal-md modal-center" role="document">
          <div className="modal-content bg-black border-light">
            <div className="modal-body text-center my-4 py-4">
              <h4 className="text-white">
                Do you want to
                <br />
                Delete this news?
              </h4>
              <div className="col-sm-12 mx-auto d-flex align-items-center mt-4 row">
                <div className="col-6 px-2">
                  <button type="button" className="btn btn-primary btn-lg btn-block font-16 rounded-pill" onClick={handleDeleteConfirm} disabled={deleting}>
                    {deleting ? "Deleting..." : "Yes"}
                  </button>
                </div>
                <div className="col-6 px-2">
                  <button type="button" className="btn btn-default btn-lg btn-block font-16 rounded-pill" onClick={handleDeleteCancel} disabled={deleting}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default NewsManagement;

